import { useEffect, useState } from "react";
import { useOrderDraft } from "../../context/OrderDraftContext";
import { useApi } from "../../hooks/useApi";
import { showError } from "../../lib/feedback";
import { packagesService } from "../../services/packages";
import { OpmeItem } from "../../types/order.types";
import { opmeToApi } from "../../lib/mappers";
import { OpmeSave } from "./useOpmeSave";

// Escolha Livre: o médico monta a lista pelo catálogo ou digita o próprio item.
export const useOpmeFreeChoice = (save: OpmeSave) => {
  const { selectedItems, setSelectedItems, setOpmeItems, surgerie, modificadoProcedimentos, modificadoOpme, setModificadoOpme, resumoOPME } = useOrderDraft();
  const { apiFetch } = useApi();
  const [catalog, setCatalog] = useState<string[] | null>(null);

  useEffect(() => {
    packagesService
      .opmes(apiFetch)
      .then((list) => setCatalog(list.map((o) => o.nome).filter(Boolean)))
      .catch((err) => {
        setCatalog([]);
        showError(err);
      });
  }, [apiFetch]);

  const selected: OpmeItem[] = selectedItems.map((s) => ({ name: s.item, quantity: s.quantity }));

  const update = (items: OpmeItem[]) => {
    setSelectedItems(items.map((i) => ({ item: i.name, quantity: i.quantity })));
    setModificadoOpme(true);
  };

  const add = (name: string, quantity = 1) => {
    if (!selected.some((s) => s.name === name)) update([...selected, { name, quantity }]);
  };

  const confirm = () => {
    const rows = selected.map(opmeToApi);
    setOpmeItems(rows);
    // Pedido salvo sem mudanças reaproveita a justificativa que já existe.
    const newSummary = !surgerie || modificadoProcedimentos || modificadoOpme || !resumoOPME;
    return save(rows, { tipo: "escolha-livre", tipoDoPacote: "", indice: -1 }, newSummary);
  };

  return {
    catalog,
    selected,
    add,
    remove: (name: string) => update(selected.filter((s) => s.name !== name)),
    setQuantity: (name: string, quantity: number) => update(selected.map((s) => (s.name === name ? { ...s, quantity } : s))),
    confirm,
  };
};
